import Footer from "../components/footer";
import Header from "../components/header";
import { useEffect } from "react";

export default function Privacy() {

    useEffect(() => {
        document.title = 'Privacy Policy - Compete';
    }, []);

    return (
        <div>
            <Header />
            <div className="section">
                    <div className="container privacy">
                        <h1>Privacy Policy</h1>
                        <p>Last updated: 16.04.2024</p>
                        <div>
                            <h2>What data does "Compete" collect about me, and why?</h2>
                            <p>We collect your username, email and game related information (ranked points and challenge results). Your username will be displayed in the app and other users can find you by that name. We will only use your email for account related actions like resetting your password.</p>
                        </div>
                        <div>
                            <h2>Does "Compete" share data about me with others?</h2>
                            <p>We do not sell or give information about you to other companies or services. However, we do use services from other companies to provide the app and website. The companies behind those services may collect data about you on their own, for their own purposes. Some of these services may be used to collect information about your online activities across different websites.</p>
                        </div>
                        <div>
                            <h2>Where does "Compete" store data about me?</h2>
                            <p>We store your username, email and game related information on servers in Europe from Google Firebase.</p>
                        </div>
                        <div>
                            <h2>Other Services</h2>
                            <p>We use the following services that collect personal data for the following purposes:</p>
                            <div className="services-table">
                                <div className="services-table-heading">
                                    <div className="services-table-left">
                                        Services
                                    </div>
                                    <div className="services-table-center">
                                        Privacy Notice
                                    </div>
                                    <div className="services-table-right">
                                        Description
                                    </div>
                                </div>
                                <div className="divider-primary"></div>
                                <div className="services-table-cell">
                                    <div className="services-table-left">
                                        <a href="https://firebase.google.com">Firebase</a>
                                    </div>
                                    <div className="services-table-center">
                                        <a href="https://firebase.google.com/support/privacy">https:<wbr></wbr>//firebase.<wbr></wbr>google.<wbr></wbr>com/<wbr></wbr>support/<wbr></wbr>privacy</a>
                                    </div>
                                    <div className="services-table-right">
                                        We use Firebase to store your information.
                                    </div>
                                </div>
                                <div className="divider-secondary"></div>
                                <div className="services-table-cell">
                                    <div className="services-table-left">
                                        <a href="https://admob.google.com/home/">AdMob</a>
                                    </div>
                                    <div className="services-table-center">
                                        <a href="https://policies.google.com/technologies/ads">https:<wbr></wbr>//policies.<wbr></wbr>google.<wbr></wbr>com/<wbr></wbr>admob/<wbr></wbr>technologies/<wbr></wbr>ads</a>
                                    </div>
                                    <div className="services-table-right">
                                        We use Admob for advertisements in the app.
                                    </div>
                                </div>
                                <div className="divider-secondary"></div>
                            </div>
                        </div>
                        <div>
                            <h2>How can I contact "Compete"?</h2>
                            <p>You can send privacy-related questions, complaints, and requests to us at hello@compete-game.com.</p>
                        </div>
                    </div>
                </div>
            <Footer />
        </div>
    )
}